import {
  ACTION_GET_CONTRACT_DETAIL,
  ACTION_GET_CONTRACT_DETAIL_RESET,
  ACTION_GET_CONTRACT_DETAIL_SUCCESS,
  ACTION_GET_CONTRACT_NUMBER_SUCCESS,
} from 'src/redux/actions/confirmContractAction/confirmContractActions'

const INITIAL_STATE = {
  contractDetail: {},
  contractNumber: null,
  loading: false,
}

const contractDetailReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_GET_CONTRACT_DETAIL:
      return {
        ...state,
        contractDetail: {},
        loading: true,
      }
    case ACTION_GET_CONTRACT_DETAIL_SUCCESS:
      return {
        ...state,
        contractDetail: action.payload,
        loading: false,
      }
    case ACTION_GET_CONTRACT_DETAIL_RESET:
      return {
        ...state,
        contractDetail: {},
        loading: false,
      }
    case ACTION_GET_CONTRACT_NUMBER_SUCCESS:
      return {
        ...state,
        contractNumber: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default contractDetailReducer
